import { render, staticRenderFns } from "./CargoStatusIcon.vue?vue&type=template&id=4a98e0d6&scoped=true&"
import script from "./CargoStatusIcon.vue?vue&type=script&lang=js&"
export * from "./CargoStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./CargoStatusIcon.vue?vue&type=style&index=0&id=4a98e0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a98e0d6",
  null
  
)

export default component.exports